import React from "react";
import ReactApexChart from "react-apexcharts";

interface Props {
  label: string;
  value: number;
  color: string;
  size?: number;
  onClick?: () => void;
  isPrint?: boolean;
  interactive?: boolean;
}

const StressCircle: React.FC<Props> = ({
  label,
  value,
  color,
  size = 130,
  onClick,
  isPrint = false,
  interactive = false,
}) => {
  if (isPrint) {
    const radius = size / 2 - 10;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (value / 100) * circumference;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: size,
        }}
      >
        <svg width={size} height={size}>
          {/* Background track */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="#e6eaf6"
            strokeWidth="10"
            fill="none"
          />

          {/* Progress arc */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={color}
            strokeWidth="10"
            fill="none"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
          />

          {/* Text */}
          <text
            x="50%"
            y="50%"
            dominantBaseline="middle"
            textAnchor="middle"
            fontSize={size >= 160 ? "24px" : "18px"}
            fontWeight="700"
            fill="#26295e"
          >
            {value}%
          </text>
        </svg>

        <div
          style={{
            marginTop: 10,
            fontSize: "14px",
            fontWeight: 500,
            color: "#26295e",
          }}
        >
          {label}
        </div>
      </div>
    );
  }
  const series = [value];

  const options: any = {
    chart: {
      type: "radialBar",
      sparkline: { enabled: true },
      toolbar: { show: false },
      selection: { enabled: false },
      zoom: { enabled: false },
    },
    tooltip: {
      enabled: false,               
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "65%",
        },
        track: {
          background: "#eef2fb",
        },
        dataLabels: {
          name: { show: false },
          value: {
            fontSize: size >= 160 ? "24px" : "14px",
            fontWeight: 700,
            color: "#26295e",
            offsetY: 4,
          },
        },
      },
    },
    stroke: { lineCap: "round" },
    colors: [color],
  };

  return (
    <div
      className={`flex flex-col items-center ${interactive ? "cursor-pointer hover:scale-105 transition" : ""
        }`}
      onClick={interactive ? onClick : undefined}
    >
      <ReactApexChart
        options={options}
        series={series}
        type="radialBar"
        height={size}
        width={size}
      />

      <div className="mt-3 text-[14px] font-medium text-[#26295e]">
        {label}
      </div>
    </div>
  );
};

export default StressCircle;